import { getMediaUrl } from '@lib/utils/url';
import { AddMediaModalRef } from '@pages/Libraries/components/AddMediaModal/AddMediaModal';
import { useLibraryFolder } from '@stores/Library/LibraryFolder';
import { Media } from '@typings/Media';
import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const useModalHandlers = () => {
  const addMediaModalRef = useRef<AddMediaModalRef>(null);
  const navigate = useNavigate();
  const folder = useLibraryFolder();

  const navigateToMedia = useCallback(
    (media: Media, event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      navigate(
        getMediaUrl(media.libraryId, media._id, {
          libraryName: folder.library?.name,
          mediaName: media.metadata?.name,
        }),
      );
    },
    [navigate, folder.library, folder.library?.name],
  );

  const handleThumbnailClick = navigateToMedia;
  const handleTitleClick = navigateToMedia;

  return {
    addMediaModalRef,
    handleThumbnailClick,
    handleTitleClick,
  };
};
